import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import { AppProviders } from "@/components/AppProviders";

const APP_ROOT_ELEMENT_ID = "root";

function getAppRootElement(): HTMLElement {
  const root = document.getElementById(APP_ROOT_ELEMENT_ID);
  if (!root) {
    throw new Error(`Missing #${APP_ROOT_ELEMENT_ID} element for React app.`);
  }
  return root;
}

export function bootstrapApp(): void {
  ReactDOM.createRoot(getAppRootElement()).render(
    <React.StrictMode>
      <AppProviders>
        <App />
      </AppProviders>
    </React.StrictMode>,
  );
}
